<template>
    <div v-if="isCurrentStep">
        <NextStep title="Turn Interviews Into Offers">
            <p>When interviewers evaluate you, they're answering three fundamental questions:</p>
            <br />
            <ol class="list-decimal ml-5">
                <li>Can I imagine this person doing the work?</li>
                <li>Can I imagine myself working with this person?</li>
                <li>Can I imagine this person staying at the company?</li>
            </ol>
            <br />
            <p>
                Practice consistently with InterviewAI to minimize red flags and present yourself as the ideal candidate
                for your target role.
            </p>
            <br />
            <p>Your interview performance improves dramatically with preparation.</p>
            <br />
            <p>
                Even 15 minutes of practice three times per week significantly increases your confidence and
                effectiveness.
            </p>
        </NextStep>
    </div>
    <div v-else-if="isStepPassed">
        <NextStep title="Review">
            <p>
                You've successfully converted interviews into job offers by addressing what employers truly evaluate:
                your ability to do the work, fit with the team, and stay with the company long-term.
            </p>
        </NextStep>
    </div>
    <div v-else>
        <NextStep title="Preview">
            <p>
                Interviewers assess if you can do the work, if they want to work with you, and if you'll stay at the
                company.
            </p>
            <br />
            <p>Regular practice with InterviewAI helps minimize red flags and build confidence.</p>
        </NextStep>
    </div>

    <button
        class="bg-won-green w-full text-white py-1.5 px-3 rounded text-sm"
        type="button"
        @click="() => emit('open-feature')"
    >
        Master Your Interview Skills →
    </button>

    <SidebarCard space-y="space-y-0">
        <span class="text-won-blue-light text-4xl font-semibold text-center">{{ interviewsCount }}</span>
        <span class="text-won-blue text-sm font-semibold text-center">Interviews</span>
    </SidebarCard>

    <PlanTabGroup :tabs="tabs" />
</template>

<script setup>
import { storeToRefs } from "pinia";

import { useJobSearchPlanStore } from "../../../store/job-search-plan.store";

import NextStep from "../next-step.vue";
import SidebarCard from "../sidebar-card.vue";
import PlanTabGroup from "../plan-tab-group.vue";

import { UserGroupIcon, UserIcon } from "@heroicons/vue/20/solid";

const emit = defineEmits(["open-feature"]);
const props = defineProps({
    isStepPassed: {
        type: Boolean,
        default: false,
        required: true,
    },
    isCurrentStep: {
        type: Boolean,
        default: false,
        required: true,
    },
});

const jobSearchPlanStore = useJobSearchPlanStore();
const { interviewsCount, interviewRate, timeToInterview } = storeToRefs(jobSearchPlanStore);

const tabs = [
    {
        title: "your average",
        icon: UserIcon,
        values: [
            { type: "percents", value: interviewRate.value, label: "Interview Rate" },
            { type: "days", value: timeToInterview.value, label: "Time to Interview" },
        ],
        isComingSoon: false,
    },
    {
        title: "other users",
        icon: UserGroupIcon,

        isComingSoon: true,
    },
];
</script>
